interface Props {
  title: string;
  imageUrl?: string | null;
  cookTimeMin?: number;
  servings?: number;
  reason?: string;
  // Калорийность порции — только экран «Калории». Если задана, поверх шапки бейдж «N ккал» (зелёный).
  // Остальные экраны проп не передают → бейджа нет.
  kcal?: number;
  onClick?: () => void;
}

export function RecipeCard({ title, imageUrl, cookTimeMin, servings, reason, kcal, onClick }: Props) {
  const meta = [cookTimeMin ? `${cookTimeMin} мин` : null, servings ? `${servings} порц.` : null]
    .filter(Boolean)
    .join(' · ');
  return (
    <button
      onClick={onClick}
      className="group block w-full overflow-hidden rounded-3xl bg-white text-left shadow-card transition duration-300 hover:-translate-y-0.5 hover:shadow-card-hover active:scale-[0.99]"
    >
      <div className="relative h-36 w-full overflow-hidden bg-gradient-to-br from-sand via-primary-300 to-primary-500">
        {imageUrl ? (
          <img
            src={imageUrl}
            alt={title}
            className="h-36 w-full object-cover transition duration-500 group-hover:scale-105"
          />
        ) : (
          <>
            {/* Мягкий блик сверху-слева даёт объём пустой шапке. */}
            <div className="absolute inset-0 bg-[radial-gradient(120%_80%_at_0%_0%,rgba(255,255,255,0.38),transparent_55%)]" />
            {/* Декоративный «тарелочный» глиф вместо плоского градиента. */}
            <svg
              viewBox="0 0 24 24"
              aria-hidden="true"
              className="absolute -bottom-4 -right-3 h-28 w-28 text-white/25"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.25"
            >
              <circle cx="12" cy="12" r="9" />
              <circle cx="12" cy="12" r="4.5" />
            </svg>
          </>
        )}
        {kcal != null && (
          <span className="absolute left-3 top-3 rounded-full bg-emerald-600 px-2.5 py-1 text-xs font-semibold text-white shadow-sm">
            {kcal} ккал
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="text-[17px] font-semibold leading-snug text-ink">{title}</h3>
        {meta && <p className="mt-1 text-sm text-ink/55">{meta}</p>}
        {reason && (
          <p className="mt-3 flex items-start gap-1.5 rounded-xl bg-primary-50 px-3 py-2 text-sm text-primary-700 ring-1 ring-inset ring-primary-100">
            <svg
              viewBox="0 0 24 24"
              aria-hidden="true"
              className="mt-0.5 h-4 w-4 shrink-0"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path
                d="M9 18h6M10 21h4M12 3a6 6 0 0 0-4 10.5c.7.7 1 1.3 1 2.5h6c0-1.2.3-1.8 1-2.5A6 6 0 0 0 12 3z"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span>{reason}</span>
          </p>
        )}
      </div>
    </button>
  );
}
